module.exports = __webpack_public_path__ + "img/karta-hometeacher.9f07f154.png";